export enum OHIFMessageType {
  CREATE_MEASURE = 'create_measure',
  DELETE_MEASURE = 'delete_measure',
  UPDATE_MEASURE = 'update_measure',
  LINK_MEASURE = 'link_measure',
  IMAGE_READY = 'image_ready',
  IMAGE_SIZE = 'image_size',
  SEND_MEASURE = 'send_measure',
  RESET_POINTS = 'reset_points',
  IMAGE_STATUS = 'image_status',
  UPDATE_TOOLBAR = 'update_toolbar',
  SAVE_SEGMENTATION = 'save_segmentation',
  SAVE_SEGMENTATION_STATS = 'save_segmentation_stats',
  SEND_SEGMENTATION_STATS = 'send_segmentation_stats',
  EXPORT_AVAILABLE = 'export_available',
  REQUEST_AUTH_TOKEN = 'request_auth_token',
  SET_AUTH_TOKEN = 'set_auth_token',
}
